import Layout from "@/components/feature/Layout";
import ServicePage from "@/components/feature/ServicePage";

const data = {
  heroTitle: "Profesyonel apartman ve site yönetimi",
  heroDescription: "Adana'da apartman ve site yönetimi için düzenli takip, profesyonel koordinasyon ve çözüm odaklı yönetim hizmeti.",
  description: "Apartman ve site yaşamında düzenin korunması, ortak alanların yönetimi, hizmet takibi ve sakinlerle iletişim profesyonel bir süreç gerektirir. Day Temizlik Adana, apartman ve siteler için düzenli takip, hizmet koordinasyonu ve çözüm odaklı yönetim anlayışı sunar. Güven, şeffaflık, düzen ve sürdürülebilir yönetim prensipleriyle çalışıyoruz.",
  scope: [
    "Ortak alan hizmetlerinin takibi",
    "Temizlik ve bakım süreçlerinin koordinasyonu",
    "Apartman ve site ihtiyaçlarının planlanması",
    "Sakinlerle iletişim sürecinin düzenlenmesi",
    "Düzenli kontrol ve raporlama",
    "Profesyonel yönetim yaklaşımı",
  ],
  forWho: [
    "Apartman yönetim kurulları",
    "Site yönetimleri",
    "Bina sahipleri",
    "Toplu konut projeleri",
  ],
  process: [
    "Apartman veya site yapısını mevcut süreçleriyle birlikte değerlendiriyoruz.",
    "Sakinlerin ve yönetim kurulunun beklentilerini dinliyoruz.",
    "Yönetim planı, bakım takvimi ve hizmet koordinasyonunu hazırlıyoruz.",
    "Düzenli takip ve kontrol mekanizması kuruyoruz.",
    "�?effaf raporlama ve sürekli iyileştirme sağlıyoruz.",
  ],
  whyProfessional: [
    "Profesyonel yönetim apartman ve site yaşam kalitesini artırır.",
    "Düzenli takip sayesinde sorunlar erken fark edilir.",
    "�?effaf raporlama sakinlerin güvenini pekiştirir.",
    "Hizmet koordinasyonu sayesinde işler aksamaz.",
    "Sürdürülebilir yönetim anlayışı uzun vadeli çözümler sunar.",
  ],
  relatedServices: [
    { title: "Apartman Temizliği", path: "/hizmetlerimiz/apartman-temizligi" },
    { title: "Bina ve Site Temizliği", path: "/hizmetlerimiz/bina-ve-site-temizligi" },
    { title: "İlaçlama", path: "/hizmetlerimiz/ilaclama" },
  ],
  faqs: [
    { question: "Site yönetimi hizmeti neleri kapsar?", answer: "Ortak alan hizmetlerinin takibi, temizlik ve bakım süreçlerinin koordinasyonu, sakinlerle iletişim ve düzenli raporlama yapılır." },
    { question: "Yönetim hizmeti fiyatı nasıl belirlenir?", answer: "Bina büyüklüğü, kat sayısı, sakin sayısı ve hizmet kapsamına göre fiyat belirlenir." },
    { question: "Sakinlerin sorunları nasıl iletilir?", answer: "Düzenli iletişim kanalları ve geri bildirim süreciyle sakinlerin talepleri hızla değerlendirilir." },
  ],
  ctaText: "Apartman veya siteniz için profesyonel yönetim çözümleri alın.",
  heroImage: "/assets/images/apartman-site-yonetimi.jpg",
};

export default function SiteYonetimiPage() {
  return (
    <Layout>
      <ServicePage data={data} />
    </Layout>
  );
}